import { useContext } from "react";
import { AddMusicSectionProps } from "./types";
import { UserDetailsContext } from "../../contexts";
import { toast } from "react-toastify";
import CustomButton from "../CustomButton/CustomButton";
import { isBillingRequired } from "../../utils/subscriptionBillingUtils";

export const AddMusicSection: React.FC<AddMusicSectionProps> = ({
  handleOpenBatchTrackAddModal,
  handleOpenUpdateSubModal,
}) => {
  const { subscriptionTier, enterprise, storageUsage, isEnterpriseAccount } =
    useContext(UserDetailsContext);

  const handleOpenAddMusicMenu = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    if (
      isBillingRequired(subscriptionTier, storageUsage) &&
      !isEnterpriseAccount
    ) {
      handleOpenUpdateSubModal();
    } else {
      handleOpenBatchTrackAddModal();
    }
  };

  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (
      enterprise &&
      enterprise.storageLimit &&
      Math.min((storageUsage / enterprise?.storageLimit) * 100, 100) >= 100
    ) {
      toast.warn("Please upgrade your enterprise storage to add more tracks");
    } else {
      handleOpenAddMusicMenu(event);
    }
  };

  return (
    <CustomButton
      text="Add Music"
      onClick={handleOnClick}
      icon="/assets/icons/TracksPageIcons/music-note-plus.svg"
    />
  );
};
